import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const ANALYSIS_IN_PROGRESS = 'analysisInProgress';

const analysingControls = new WeakSet<AbstractControl>();

const analysisInProgressValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null =>
  analysingControls.has(control) ? { [ANALYSIS_IN_PROGRESS]: true } : null;

export function holdWhileAnalysing(control: AbstractControl | null | undefined, analysing: boolean): void {
  if (!control) {
    return;
  }
  if (!control.hasValidator(analysisInProgressValidator)) {
    control.addValidators(analysisInProgressValidator);
  }
  if (analysing) {
    analysingControls.add(control);
  } else {
    analysingControls.delete(control);
  }
  control.updateValueAndValidity();
}
